export default "__VITE_ASSET__BCcLP0b9__"